// "ReportsHome.jsx"

import React from "react";
import styles from "./ReportsHome.module.css"; // i tuoi stili utente
import CommonReportsPage from "@/commons/tickets/CommonReportsPage";
import { environment } from "@/commons/configs/Config";
import Cookies from "js-cookie";

import Header from "@/commons/pages/borders/header/Header";
import Footer from "@/commons/pages/borders/footer/Footer";
import Redirects from "@/commons/utils/Redirects";

/** Funzione fetch per i report utente */
async function fetchUserReports(filter, page, itemsPerPage) {
    const userToken = Cookies.get(environment.accessToken);
    const url = `${environment.apiUrlTwo}/posts/getFiltered?status=${filter}`;
    const pageData = { page, items: itemsPerPage };

    const resp = await fetch(url, {
        method: "POST",
        headers: {
            Authorization: userToken,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(pageData),
    });
    if (resp.status === 200) {
        return await resp.json(); // {content: [...], totalElements: number}
    } else {
        return { content: [], totalElements: 0 };
    }
}

function ReportsHome() {
    function handleReportClick(reportId, event) {
        event.preventDefault();
        Redirects.domainSendClick("reports", "post/"+reportId, event)
    }

    return (
        <>
            <div className={"page__body"}>
                <Header/>
                <div className={"page__content"}>
                    <div className={styles.ReportsMainBox}>
                        <CommonReportsPage
                            pageTitle="I miei Reports"
                            fetchReports={fetchUserReports}
                            onReportClick={handleReportClick}
                            colorBackgrounds={false}
                            newReportButtonUrl="/tickets"
                        />
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
}

export default ReportsHome;